import { acceptHMRUpdate, defineStore , storeToRefs} from 'pinia'
import { reactive } from 'vue'
import { getEventOrganizerByIdAndPartitionKeyApi } from '@/api'
import { useErrorStore } from '@/stores/errorStore'
import { useUserStore } from '@/stores/userStore'
const userStore = useUserStore()
const { user } = storeToRefs(userStore)

import { createEventOrganizer, deleteEventOrganizerById, getEventOrganizerById, updateEventOrganizer } from '@/api'
import type { EventOrganizer, ItemReference } from '@/types'
import { useAuthenticationStore } from './useAuthenticationStore'

export interface EventOrganizerStore {
    eventOrganizers: EventOrganizer[]
    getEventOrganizer(id: number): EventOrganizer | undefined
    getEventOrganizerByIdAndPartitionKey(id: number, partitionKey:string): Promise<EventOrganizer>
    addNewEventOrganizer(eventOrganizer: EventOrganizer): Promise<void>
    loadEventOrganizersForUser(): Promise<void>
    deleteEventOrganizer(eo: EventOrganizer): Promise<void>
    updateExistingEventOrganizer(organizerToUpdate: EventOrganizer): Promise<void>
}

export const useEventOrganizerStore = defineStore<'eventOrganizer', EventOrganizerStore>(
    'eventOrganizer',
    function (): EventOrganizerStore {
        const authStore = useAuthenticationStore()
        const errorStore = useErrorStore()
        const eventOrganizers = reactive<EventOrganizer[]>([])
    
        async function loadEventOrganizersForUser() {
            eventOrganizers.length = 0;
            await userStore.loadUser();
            var organizers = user.value.organizerFor
    
            for (const eventOrganizer of await Promise.all(
                organizers.map((x) => getEventOrganizerById(x.id as number, x.partitionKey))
            )) {
                if (eventOrganizers.find((x) => x.id === eventOrganizer.id) === undefined) {
                    eventOrganizers.push(eventOrganizer);
                }
            }
        }

        function getEventOrganizer(id: number): EventOrganizer | undefined {
            return eventOrganizers.find((x) => x.id === id)
        }
        
        async function getEventOrganizerByIdAndPartitionKey(id: number, partitionKey:string) : Promise<EventOrganizer> {
            
            return await  getEventOrganizerByIdAndPartitionKeyApi(id, partitionKey);
        }


        async function addNewEventOrganizer(organizerToAdd: EventOrganizer) {
            try {
                const newOrganizer = await createEventOrganizer(authStore.userId as string, organizerToAdd)
                eventOrganizers.push(newOrganizer as EventOrganizer)
            } catch (e) {
                console.error(e)
                errorStore.error.message = 'En fejl er opstået'
                errorStore.error.show = true
            }
        }
        async function updateExistingEventOrganizer(organizerToUpdate: EventOrganizer) {
            try {
                const updatedOrganizer = await updateEventOrganizer(organizerToUpdate)
                const existingOrganizerIndex = eventOrganizers.findIndex((org) => org.id === updatedOrganizer.id)

                if (existingOrganizerIndex !== -1) {
                    eventOrganizers.splice(existingOrganizerIndex, 1, updatedOrganizer)
                }
            } catch (e) {
                console.error(e)
                errorStore.error.message = 'En fejl er opstået'
                errorStore.error.show = true
            }
        }
        async function deleteEventOrganizer(eo: EventOrganizer): Promise<void> {
            await deleteEventOrganizerById(eo.id, eo.partitionKey, authStore.userId as string)
            await loadEventOrganizersForUser();
        }

       

        return {
            addNewEventOrganizer,
            deleteEventOrganizer,
            eventOrganizers,
            getEventOrganizer,
            getEventOrganizerByIdAndPartitionKey,
            loadEventOrganizersForUser,
            updateExistingEventOrganizer
        }
    }
)
// make sure to pass the right store definition, `useAuth` in this case.
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useEventOrganizerStore, import.meta.hot))
}
